import { styled } from "@obby/components";

export const Box = styled("div", {
  variants: {
    variant: {
      salesBox: {
        fontFamily: "$foundersGrotesk",
        letterSpacing: "0.3px"
      },
      title: {
        position: "relative",
        margin: "0 0 20px"
      },
      description: {
        fontSize: "$18",
        lineHeight: "$2",
        margin: "0 0 1.9rem",
        fontWeight: "2"
      }
    },
    fontSize: {
      medium: {
        fontFamily: "$foundersGroteskCondensed",
        fontWeight: "$3",
        fontSize: "$28",
        lineHeight: "1.2",
        textTransform: "uppercase",

        "@media (min-width: 414px)": {
          fontSize: "$32"
        }
      },
      large: {
        fontFamily: "$foundersGroteskXCondensed",
        fontWeight: "$1",
        fontSize: "$lParagraph",
        lineHeight: "1.2",
        textTransform: "uppercase"
      },
      xLarge: {
        fontFamily: "$foundersGroteskXCondensed",
        textTransform: "uppercase",
        fontWeight: "$1",
        fontSize: "2.8rem",
        lineHeight: "1",

        "@lg": {
          fontSize: "80px",
          lineHeight: "1"
        }
      }
    }
  }
});
